import React from 'react';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { CompetitorASIN } from '../../types';

interface CompetitorsTabProps {
  competitors: CompetitorASIN[];
  columns: ColumnsType<CompetitorASIN>;
}

/**
 * 竞争对手Tab组件
 * 展示竞品ASIN列表和威胁等级信息
 */
export const CompetitorsTab: React.FC<CompetitorsTabProps> = ({ competitors, columns }) => {
  return (
    <Table
      dataSource={competitors}
      columns={columns}
      rowKey="id"
      pagination={{
        pageSize: 10,
        showTotal: (total) => `共 ${total} 个竞品`,
      }}
    />
  );
};

